/** Strip legacy summary paragraphs already shown in the status banner. */
export function displaySummaryHe(summary: string): string {
  return summary
    .replace(/^ייעוד הקרקע[^.]+\.\s*/u, '')
    .replace(/^ייעוד קרקע:\s*[^.]+\.\s*/u, '')
    .replace(/\s*ייעוד קרקע:\s*[^.]+\.\s*/gu, ' ')
    .trim();
}

export function trafficLightMeaning(full: string): string {
  const dash = full.indexOf('—');
  return dash >= 0 ? full.slice(dash + 1).trim() : full;
}
